<template>
  <ContentWrap class="penalty-page">
    <el-alert
      class="mb-16px"
      type="info"
      :closable="false"
      title="运营端 · 风控落罚与申诉。黑名单仅平台可落；机构仅警告/限接。待审可「关闭」无需落罚；已落罚可「撤销」或走申诉审。"
    />

    <el-tabs v-model="activeTab" class="penalty-tabs" @tab-change="onTabChange">
      <!-- 待审进审 -->
      <el-tab-pane name="reviews">
        <template #label>
          <span>
            待审进审
            <el-badge v-if="openReviewCount" :value="openReviewCount" class="ml-6px" />
          </span>
        </template>

        <div class="toolbar">
          <el-form inline @submit.prevent>
            <el-form-item label="骑手手机">
              <el-input v-model="manualPhone" clearable placeholder="11 位手机号" class="!w-160px" />
            </el-form-item>
            <el-form-item label="运单号">
              <el-input v-model="manualWaybill" clearable placeholder="运单号" class="!w-180px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onOpenReview">手动进审</el-button>
              <el-button @click="loadReviews">刷新</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table
          v-loading="reviewsLoading"
          :data="reviews"
          border
          stripe
          class="penalty-table"
          empty-text="暂无进审记录"
        >
          <el-table-column prop="reviewId" label="进审号" min-width="130" show-overflow-tooltip />
          <el-table-column prop="phone" label="骑手" min-width="120" />
          <el-table-column prop="waybillId" label="运单" min-width="150" show-overflow-tooltip />
          <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="reviewStatusType(row.status)" size="small">
                {{ reviewStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="进审时间" min-width="168" show-overflow-tooltip>
            <template #default="{ row }">{{ formatCapacityDateTime(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right" align="center">
            <template #default="{ row }">
              <template v-if="row.status === 'open'">
                <el-button link type="danger" @click="openApplyDialog(row)">落罚</el-button>
                <el-button link type="info" @click="onDismiss(row.reviewId)">关闭</el-button>
              </template>
              <span v-else class="muted">已处理</span>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="reviewsTotal"
          v-model:page="reviewsPageNo"
          v-model:limit="reviewsPageSize"
          @pagination="loadReviews"
        />
      </el-tab-pane>

      <!-- 申诉审核 -->
      <el-tab-pane name="appeals">
        <template #label>
          <span>
            申诉审核
            <el-badge v-if="pendingAppealCount" :value="pendingAppealCount" class="ml-6px" />
          </span>
        </template>

        <div class="toolbar">
          <el-button type="primary" @click="loadAppeals">刷新</el-button>
          <el-checkbox v-model="appealsPendingOnly" class="ml-12px" @change="onAppealsFilterChange">
            仅看待审
          </el-checkbox>
        </div>

        <el-table
          v-loading="appealsLoading"
          :data="appeals"
          border
          stripe
          class="penalty-table"
          empty-text="暂无申诉"
        >
          <el-table-column prop="appealId" label="申诉号" min-width="130" show-overflow-tooltip />
          <el-table-column prop="phone" label="骑手" min-width="120" />
          <el-table-column prop="penaltyId" label="关联处罚" min-width="130" show-overflow-tooltip />
          <el-table-column prop="reason" label="申诉理由" min-width="180" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="appealStatusType(row.status)" size="small">
                {{ appealStatusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="decisionNote" label="审结说明" min-width="140" show-overflow-tooltip />
          <el-table-column label="提交时间" min-width="168" show-overflow-tooltip>
            <template #default="{ row }">{{ formatCapacityDateTime(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right" align="center">
            <template #default="{ row }">
              <template v-if="row.status === 'pending'">
                <el-button link type="success" @click="onDecide(row.appealId, true)">通过</el-button>
                <el-button link type="danger" @click="onDecide(row.appealId, false)">驳回</el-button>
              </template>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="appealsTotal"
          v-model:page="appealsPageNo"
          v-model:limit="appealsPageSize"
          @pagination="loadAppeals"
        />
      </el-tab-pane>

      <!-- 处罚记录 -->
      <el-tab-pane label="处罚记录" name="penalties">
        <div class="toolbar">
          <el-form inline @submit.prevent>
            <el-form-item label="骑手手机">
              <el-input
                v-model="penaltyPhoneFilter"
                clearable
                placeholder="留空查全部"
                class="!w-160px"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchPenalties">查询</el-button>
              <el-button @click="resetPenaltyFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table
          v-loading="penaltiesLoading"
          :data="penaltyList"
          border
          stripe
          class="penalty-table"
          empty-text="暂无处罚记录"
        >
          <el-table-column prop="penaltyId" label="处罚 ID" min-width="130" show-overflow-tooltip />
          <el-table-column prop="phone" label="骑手" min-width="120" />
          <el-table-column label="档位" width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="levelTagType(row.level)" size="small">
                {{ levelLabel(row.level) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="waybillId" label="运单" min-width="140" show-overflow-tooltip />
          <el-table-column label="金额/天数" min-width="120">
            <template #default="{ row }">
              <span v-if="row.level === 'fine'">¥{{ row.amount ?? '—' }}</span>
              <span v-else-if="row.level === 'limit_accept'">{{ row.days ?? '—' }} 天</span>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="操作方" width="90" align="center">
            <template #default="{ row }">{{ penaltyActorRoleLabel(row.actorRole) }}</template>
          </el-table-column>
          <el-table-column label="有效" width="80" align="center">
            <template #default="{ row }">
              <el-tag :type="row.active ? 'danger' : 'info'" size="small">
                {{ row.active ? '生效' : '已撤销' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="原因" min-width="160" show-overflow-tooltip />
          <el-table-column label="落地时间" min-width="168" show-overflow-tooltip>
            <template #default="{ row }">{{ formatCapacityDateTime(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="90" fixed="right" align="center">
            <template #default="{ row }">
              <el-button v-if="row.active" link type="warning" @click="onRevoke(row.penaltyId)">
                撤销
              </el-button>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="penaltiesTotal"
          v-model:page="penaltiesPageNo"
          v-model:limit="penaltiesPageSize"
          @pagination="loadPenalties"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- 落罚弹窗 -->
    <el-dialog
      v-model="applyDialogVisible"
      title="人工落罚"
      width="480px"
      destroy-on-close
      @closed="resetApplyDialog"
    >
      <template v-if="applyTarget">
        <el-descriptions :column="1" border size="small" class="mb-16px">
          <el-descriptions-item label="进审号">{{ applyTarget.reviewId }}</el-descriptions-item>
          <el-descriptions-item label="骑手">{{ applyTarget.phone }}</el-descriptions-item>
          <el-descriptions-item label="运单">{{ applyTarget.waybillId }}</el-descriptions-item>
          <el-descriptions-item label="进审原因">{{ applyTarget.reason || '—' }}</el-descriptions-item>
        </el-descriptions>

        <el-form label-width="88px">
          <el-form-item label="处罚档位" required>
            <el-select v-model="applyDraft.level" class="!w-full">
              <el-option label="警告" value="warn" />
              <el-option label="扣款" value="fine" />
              <el-option label="限接" value="limit_accept" />
              <el-option label="黑名单" value="blacklist" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="applyDraft.level === 'fine'" label="扣款金额" required>
            <el-input-number
              v-model="applyDraft.amount"
              :min="0.01"
              :precision="2"
              :step="1"
              class="!w-full"
            />
          </el-form-item>
          <el-form-item v-if="applyDraft.level === 'limit_accept'" label="限接天数" required>
            <el-input-number v-model="applyDraft.days" :min="1" :max="365" class="!w-full" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="applyDraft.reason"
              type="textarea"
              :rows="2"
              maxlength="200"
              show-word-limit
              placeholder="落罚说明（可选）"
            />
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button @click="applyDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="applySubmitting" @click="confirmApply">确认落罚</el-button>
      </template>
    </el-dialog>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as PenaltyApi from '@/api/capacity/penalty'
import { formatCapacityDateTime, penaltyActorRoleLabel } from '@/api/capacity/labels'
import { ContentWrap } from '@/components/ContentWrap'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRoute } from 'vue-router'

defineOptions({ name: 'CapacityPenaltyDemo' })

const route = useRoute()
const activeTab = ref('reviews')

const reviews = ref<PenaltyApi.RiskReview[]>([])
const reviewsPageNo = ref(1)
const reviewsPageSize = ref(10)
const reviewsTotal = ref(0)
const reviewsLoading = ref(false)
const openReviewCount = ref(0)

const appeals = ref<PenaltyApi.AppealRecord[]>([])
const appealsPageNo = ref(1)
const appealsPageSize = ref(10)
const appealsTotal = ref(0)
const appealsLoading = ref(false)
const appealsPendingOnly = ref(false)
const pendingAppealCount = ref(0)

const penaltyList = ref<PenaltyApi.PenaltyRecord[]>([])
const penaltiesPageNo = ref(1)
const penaltiesPageSize = ref(10)
const penaltiesTotal = ref(0)
const penaltiesLoading = ref(false)
const penaltyPhoneFilter = ref('')

const manualPhone = ref('')
const manualWaybill = ref('')

const applyDialogVisible = ref(false)
const applyTarget = ref<PenaltyApi.RiskReview | null>(null)
const applySubmitting = ref(false)
const applyDraft = reactive({
  level: 'warn',
  amount: 10,
  days: 3,
  reason: '平台人工落罚'
})

function reviewStatusLabel(status: string) {
  return status === 'open' ? '待审' : '已关闭'
}

function reviewStatusType(status: string) {
  return status === 'open' ? 'warning' : 'info'
}

function appealStatusLabel(status: string) {
  const map: Record<string, string> = {
    pending: '待审',
    approved: '已通过',
    rejected: '已驳回'
  }
  return map[status] || status
}

function appealStatusType(status: string) {
  const map: Record<string, string> = {
    pending: 'warning',
    approved: 'success',
    rejected: 'danger'
  }
  return map[status] || 'info'
}

function levelLabel(level: string) {
  const map: Record<string, string> = {
    warn: '警告',
    fine: '扣款',
    limit_accept: '限接',
    blacklist: '黑名单'
  }
  return map[level] || level
}

function levelTagType(level: string) {
  const map: Record<string, string> = {
    warn: 'info',
    fine: 'warning',
    limit_accept: 'danger',
    blacklist: 'danger'
  }
  return map[level] || 'info'
}

const loadReviews = async () => {
  reviewsLoading.value = true
  try {
    const r = await PenaltyApi.listReviews({
      pageNo: reviewsPageNo.value,
      pageSize: reviewsPageSize.value
    })
    reviews.value = r?.list || []
    reviewsTotal.value = r?.total || 0
  } finally {
    reviewsLoading.value = false
  }
}

const loadAppeals = async () => {
  appealsLoading.value = true
  try {
    const r = await PenaltyApi.listAppeals({
      pendingOnly: appealsPendingOnly.value || undefined,
      pageNo: appealsPageNo.value,
      pageSize: appealsPageSize.value
    })
    appeals.value = r?.list || []
    appealsTotal.value = r?.total || 0
  } finally {
    appealsLoading.value = false
  }
}

const loadPenalties = async () => {
  penaltiesLoading.value = true
  try {
    const phone =
      penaltyPhoneFilter.value.trim() ||
      String(route.query.phone || '').trim() ||
      undefined
    const r = await PenaltyApi.listPenalties({
      phone,
      pageNo: penaltiesPageNo.value,
      pageSize: penaltiesPageSize.value
    })
    penaltyList.value = r?.list || []
    penaltiesTotal.value = r?.total || 0
  } finally {
    penaltiesLoading.value = false
  }
}

const refreshBadges = async () => {
  const [openReviews, pendingAppeals] = await Promise.all([
    PenaltyApi.listReviews({ openOnly: true, pageNo: 1, pageSize: 1 }),
    PenaltyApi.listAppeals({ pendingOnly: true, pageNo: 1, pageSize: 1 })
  ])
  openReviewCount.value = openReviews?.total || 0
  pendingAppealCount.value = pendingAppeals?.total || 0
}

const onTabChange = (name: string | number) => {
  if (name === 'reviews') loadReviews()
  else if (name === 'appeals') loadAppeals()
  else if (name === 'penalties') loadPenalties()
}

const onAppealsFilterChange = () => {
  appealsPageNo.value = 1
  loadAppeals()
}

const searchPenalties = () => {
  penaltiesPageNo.value = 1
  loadPenalties()
}

const resetPenaltyFilter = () => {
  penaltyPhoneFilter.value = ''
  penaltiesPageNo.value = 1
  loadPenalties()
}

const onOpenReview = async () => {
  const phone = manualPhone.value.trim()
  const waybillId = manualWaybill.value.trim()
  if (!phone || !waybillId) {
    ElMessage.warning('请填写骑手手机与运单号')
    return
  }
  const r = await PenaltyApi.openReview(phone, waybillId, '人工进审')
  if (!r.success) {
    ElMessage.error(r.message || '进审失败')
    return
  }
  ElMessage.success('已进审')
  await Promise.all([loadReviews(), refreshBadges()])
}

const openApplyDialog = (row: PenaltyApi.RiskReview) => {
  applyTarget.value = row
  applyDraft.level = 'warn'
  applyDraft.amount = 10
  applyDraft.days = 3
  applyDraft.reason = '平台人工落罚'
  applyDialogVisible.value = true
}

const resetApplyDialog = () => {
  applyTarget.value = null
  applySubmitting.value = false
}

const confirmApply = async () => {
  if (!applyTarget.value) return
  applySubmitting.value = true
  try {
    const r = await PenaltyApi.applyPenalty({
      actorId: 'platform',
      actorRole: 'platform',
      reviewId: applyTarget.value.reviewId,
      level: applyDraft.level,
      amount: applyDraft.level === 'fine' ? applyDraft.amount : undefined,
      days: applyDraft.level === 'limit_accept' ? applyDraft.days : undefined,
      reason: applyDraft.reason || '平台人工落罚'
    })
    if (!r.success) {
      ElMessage.error(r.message || '落罚失败')
      return
    }
    ElMessage.success('处罚已落地')
    applyDialogVisible.value = false
    await Promise.all([loadReviews(), loadPenalties(), refreshBadges()])
  } finally {
    applySubmitting.value = false
  }
}

const onDismiss = async (reviewId: string) => {
  try {
    const { value } = await ElMessageBox.prompt('关闭原因（可选）', '关闭进审', {
      confirmButtonText: '确认关闭',
      cancelButtonText: '取消',
      inputPlaceholder: '无需落罚，仅关闭待审'
    })
    const r = await PenaltyApi.dismissReview(reviewId, value || undefined)
    if (!r.success) {
      ElMessage.error(r.message || '关闭失败')
      return
    }
    ElMessage.success('进审已关闭')
    await Promise.all([loadReviews(), refreshBadges()])
  } catch {
    /* 用户取消 */
  }
}

const onRevoke = async (penaltyId: string) => {
  try {
    await ElMessageBox.confirm('撤销后将解除限接/黑名单并退回扣款（如有），确认？', '撤销处罚', {
      type: 'warning',
      confirmButtonText: '确认撤销',
      cancelButtonText: '取消'
    })
    const r = await PenaltyApi.revokePenalty(penaltyId, 'platform', '平台撤销')
    if (!r.success) {
      ElMessage.error(r.message || '撤销失败')
      return
    }
    ElMessage.success('处罚已撤销')
    await loadPenalties()
  } catch {
    /* 用户取消 */
  }
}

const onDecide = async (appealId: string, approve: boolean) => {
  const r = await PenaltyApi.decideAppeal(
    appealId,
    approve,
    approve ? '平台撤销/补款' : '证据不足'
  )
  if (!r.success) {
    ElMessage.error(r.message || '审申诉失败')
    return
  }
  ElMessage.success(approve ? '已通过' : '已驳回')
  await Promise.all([loadAppeals(), loadPenalties(), refreshBadges()])
}

onMounted(async () => {
  const qPhone = String(route.query.phone || '').trim()
  if (qPhone) {
    manualPhone.value = qPhone
    penaltyPhoneFilter.value = qPhone
  }
  await Promise.all([loadReviews(), loadAppeals(), loadPenalties(), refreshBadges()])
})
</script>

<style scoped lang="scss">
.penalty-page {
  :deep(.el-tabs__header) {
    margin-bottom: 16px;
  }
}

.toolbar {
  margin-bottom: 12px;
}

.penalty-table {
  width: 100%;
}

.muted {
  font-size: 12px;
  color: var(--el-text-color-secondary);
}
</style>
